import type {
  WordStudy,
  WordStudyFormData,
} from "@/types/models/Exportables.interface";

/**
 * Transforms WordStudy API response (with words array) to flat WordStudyFormData structure.
 * Extracts the first word from the array and flattens it to the form structure.
 *
 * @param wordStudy - API response with words array
 * @param existingFormData - Optional existing form data to preserve certain fields
 * @returns Flat WordStudyFormData or null if no words available
 */
export function transformWordStudyToFormData(
  wordStudy: WordStudy | Record<string, any>,
  existingFormData?: Partial<WordStudyFormData>,
): WordStudyFormData | null {
  const words = wordStudy.words;
  if (!Array.isArray(words) || words.length === 0) return null;

  const firstWord = words[0];
  if (!firstWord) return null;

  return {
    ...(wordStudy.article_title && { article_title: wordStudy.article_title }),
    ...(existingFormData?.articleShortTitle && {
      articleShortTitle: existingFormData.articleShortTitle,
    }),
    word: firstWord.word,
    prefix: firstWord.prefix ?? "",
    prefix_meaning: firstWord.prefix_meaning ?? "",
    root_word: firstWord.root_word ?? "",
    root_word_meaning: firstWord.root_word_meaning ?? "",
    suffix: firstWord.suffix ?? "",
    suffix_meaning: firstWord.suffix_meaning ?? "",
    definition: firstWord.definition,
    related_words: firstWord.related_words,
    sentence: existingFormData?.sentence ?? "",
  };
}
